import { useEffect, useState } from "react";

export const getSAMode = () => localStorage.getItem("sa_mode") || "super";

export const setSAMode = (m) => {
  localStorage.setItem("sa_mode", m);
  window.dispatchEvent(new Event("sa-mode"));
};

export const useSAMode = () => {
  const [mode, setMode] = useState(getSAMode());
  useEffect(() => {
    const h = () => setMode(getSAMode());
    window.addEventListener("sa-mode", h);
    return () => window.removeEventListener("sa-mode", h);
  }, []);
  return mode;
};
